{
  "identities.messages.1010001": "ログイン",
  "identities.messages.1010002": "{provider}でログイン",
  "identities.messages.1010003": "これが自分であることを確認するために、この操作を承認してください。",
  "identities.messages.1010004": "2段階認証の挑戦を完了してください。",
  "identities.messages.1010005": "確認",
  "identities.messages.1010006": "認証コード",
  "identities.messages.1010007": "バックアップ復旧コード",
  "identities.messages.1010008": "ハードウェアキーで続行",
  "identities.messages.1010009": "続行",
  "identities.messages.1010010": "続行",
  "identities.messages.1010011": "ハードウェアキーでログイン",
  "identities.messages.1010012": "WebAuthnデバイス（例：セキュリティキー、バイオメトリクススキャナーなど）を準備し、続行を押してください。",
  "identities.messages.1010013": "続行",
  "identities.messages.1010014": "提供されたアドレスにコードが送信されました。受信していない場合は、アドレスのスペルミスを確認し、再試行してください。",
  "identities.messages.1010015": "ログインコードを送信",
  "identities.messages.1010016": "「{duplicateIdentifier}」でログインしようとしたのですが、このメールアドレスは別のアカウントで既に使用されています。以下のオプションのいずれかでアカウントにログインし、{provider}の「{duplicateIdentifier}」を別のログイン方法として追加してください。",
  "identities.messages.1010017": "ログインしてリンク",
  "identities.messages.1010018": "{provider}で確認",
  "identities.messages.1010019": "続行するためのコードをリクエスト",
  "identities.messages.1010021": "パスキーでログイン",
  "identities.messages.1010022": "パスワードでログイン",
  "identities.messages.1010023": "{address}にコードを送信",
  "identities.messages.1040001": "アカウント登録",
  "identities.messages.1040002": "{provider}で登録",
  "identities.messages.1040003": "続行",
  "identities.messages.1040004": "セキュリティキーで登録",
  "identities.messages.1040005": "提供されたアドレスにコードが送信されました。メールが届いていない場合は、アドレスのスペルミスを確認し、登録を再試行してください。",
  "identities.messages.1040006": "登録コードを送信",
  "identities.messages.1040007": "パスキーで登録",
  "identities.messages.1040008": "戻る",
  "identities.messages.1040009": "認証に使用する資格情報を選択してください。",
  "identities.messages.1050001": "変更が保存されました！",
  "identities.messages.1050002": "{provider}をリンク",
  "identities.messages.1050003": "{provider}を解除",
  "identities.messages.1050004": "TOTP認証アプリを解除",
  "identities.messages.1050005": "認証アプリのQRコード",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "バックアップ復旧コードを表示",
  "identities.messages.1050008": "有効化",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "これらがあなたのバックアップ復旧コードです。安全な場所に保管してください！",
  "identities.messages.1050011": "バックアップ復旧コードを確認",
  "identities.messages.1050012": "セキュリティキーを追加",
  "identities.messages.1050013": "セキュリティキーの名前",
  "identities.messages.1050014": "{used_at, date, long}に使用された秘密",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "この方法を無効化",
  "identities.messages.1050017": "認証用シークレット",
  "identities.messages.1050018": "セキュリティキー「{display_name}」を削除",
  "identities.messages.1050019": "パスキーを追加",
  "identities.messages.1050020": "パスキー「{display_name}」を削除",
  "identities.messages.1060001": "アカウントの復旧に成功しました。次の{privileged_session_expires_at_unix_until_minutes}分以内にパスワードを変更するか、代替のログイン方法（例：ソーシャルログイン）を設定してください。",
  "identities.messages.1060002": "復旧リンクを含むメールが、ご提供いただいたメールアドレスに送信されました。メールが届いていない場合は、アドレスのスペルミスを確認し、登録時に使用したアドレスを使用しているか確認してください。",
  "identities.messages.1060003": "復旧コードを含むメールが、ご提供いただいたメールアドレスに送信されました。メールが届いていない場合は、アドレスのスペルミスを確認し、登録時に使用したアドレスを使用しているか確認してください。",
  "identities.messages.1060004": "復旧コードが「{masked_address}」に送信されました。受信していない場合は、アドレスのスペルミスを確認し、登録時に使用したアドレスを使用しているか確認してください。",
  "identities.messages.1060005": "完全な復旧アドレスを提供することで、アカウントへのアクセスを復旧してください。",
  "identities.messages.1060006": "アカウントをどのように復旧しますか？",
  "identities.messages.1060007": "戻る",
  "identities.messages.1070001": "パスワード",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "保存",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "送信",
  "identities.messages.1070006": "コードを確認",
  "identities.messages.1070007": "メールアドレス",
  "identities.messages.1070008": "コードを再送",
  "identities.messages.1070009": "続行",
  "identities.messages.1070010": "復旧コード",
  "identities.messages.1070011": "検証コード",
  "identities.messages.1070012": "登録コード",
  "identities.messages.1070013": "ログインコード",
  "identities.messages.1070014": "ログインして資格情報をリンク",
  "identities.messages.1070015": "続行するにはCAPTCHAチャレンジを完了してください。",
  "identities.messages.1070016": "復旧アドレス",
  "identities.messages.1070017": "電話番号",
  "identities.messages.1080001": "検証リンクを含むメールが、ご提供いただいたメールアドレスに送信されました。メールが届いていない場合は、アドレスのスペルミスを確認し、登録時に使用したアドレスを使用しているか確認してください。",
  "identities.messages.1080002": "メールアドレスの検証に成功しました。",
  "identities.messages.1080003": "検証コードを含むメールが、ご提供いただいたメールアドレスに送信されました。メールが届いていない場合は、アドレスのスペルミスを確認し、登録時に使用したアドレスを使用しているか確認してください。",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "{property}を入力して再試行してください。",
  "identities.messages.4000003": "長さは{min_length}以上でなければなりませんが、{actual_length}です。",
  "identities.messages.4000004": "パターン「{pattern}」に一致していません。",
  "identities.messages.4000005": "パスワードは{reason}のため使用できません。",
  "identities.messages.4000006": "提供された資格情報が無効です。パスワード、ユーザー名、メールアドレス、または電話番号にスペルミスがないか確認してください。",
  "identities.messages.4000007": "同じ識別子（メールアドレス、電話番号、ユーザー名など）のアカウントが既に存在します。",
  "identities.messages.4000008": "提供された認証コードが無効です。再試行してください。",
  "identities.messages.4000009": "ログイン識別子が見つかりません。設定を忘れていないか確認してください。これはサーバーの誤設定による可能性もあります。",
  "identities.messages.4000010": "アカウントがまだ有効になっていません。メールアドレスの検証を行ったでしょうか？",
  "identities.messages.4000011": "TOTPデバイスが設定されていません。",
  "identities.messages.4000012": "このバックアップ復旧コードはすでに使用されています。",
  "identities.messages.4000013": "WebAuthnデバイスが設定されていません。",
  "identities.messages.4000014": "バックアップ復旧コードが設定されていません。",
  "identities.messages.4000015": "このアカウントは存在しないか、セキュリティキーが設定されていません。",
  "identities.messages.4000016": "このバックアップ復旧コードは無効です。",
  "identities.messages.4000017": "長さは{max_length}以下でなければなりませんが、{actual_length}です。",
  "identities.messages.4000018": "{minimum}以上でなければなりませんが、{actual}です。",
  "identities.messages.4000019": "{minimum}より大きくなければなりませんが、{actual}です。",
  "identities.messages.4000020": "{maximum}以下でなければなりませんが、{actual}です。",
  "identities.messages.4000021": "{maximum}より小さくなければなりませんが、{actual}です。",
  "identities.messages.4000022": "{actual}は{base}の倍数ではありません。",
  "identities.messages.4000023": "最大{max_items}個まで許可されていますが、{actual_items}個あります。",
  "identities.messages.4000024": "最小{min_items}個以上必要ですが、{actual_items}個あります。",
  "identities.messages.4000025": "インデックス{index_a}と{index_b}の項目が同じです。",
  "identities.messages.4000026": "期待される型は{allowed_types_list}ですが、{actual_type}です。",
  "identities.messages.4000027": "同じ識別子（メールアドレス、電話番号、ユーザー名など）のアカウントが既に存在します。既存のアカウントにログインして、ソーシャルプロフィールをリンクしてください。",
  "identities.messages.4000028": "{credential_identifier_hint}でログインしようとしたのですが、このアカウントは別のアカウントで既に使用されています。{available_credential_types_list}でログインできます。以下のソーシャルログインプロバイダーでログインできます：{available_oidc_providers_list}。",
  "identities.messages.4000029": "定数{expected}と等しくなければなりません。",
  "identities.messages.4000030": "定数の検証に失敗しました。",
  "identities.messages.4000031": "パスワードは識別子と似すぎているため使用できません。",
  "identities.messages.4000032": "パスワードは{min_length}文字以上でなければなりませんが、{actual_length}文字です。",
  "identities.messages.4000033": "パスワードは{max_length}文字以下でなければなりませんが、{actual_length}文字です。",
  "identities.messages.4000034": "このパスワードはデータ漏洩の履歴にあり、使用できなくなりました。",
  "identities.messages.4000035": "このアカウントは存在しないか、コードによるログインが設定されていません。",
  "identities.messages.4000036": "提供された属性が、このフローに関連付けられた以前の属性と一致しません。",
  "identities.messages.4000037": "このアカウントは存在しないか、ログイン方法が設定されていません。",
  "identities.messages.4000038": "CAPTCHAの検証に失敗しました。再試行してください。",
  "identities.messages.4010001": "操作の有効期限が切れています。もう一度お試しください。",
  "identities.messages.4010002": "ログインするための戦略が見つかりません。フォームを正しく入力しましたか？",
  "identities.messages.4010003": "登録するための戦略が見つかりません。フォームを正しく入力しましたか？",
  "identities.messages.4010004": "設定を更新するための戦略が見つかりません。フォームを正しく入力しましたか？",
  "identities.messages.4010005": "アカウントを復旧するための戦略が見つかりません。フォームを正しく入力しましたか？",
  "identities.messages.4010006": "アカウントを検証するための戦略が見つかりません。フォームを正しく入力しましたか？",
  "identities.messages.4010007": "リクエストはすでに成功裏に完了しており、再試行できません。",
  "identities.messages.4010008": "ログインコードが無効またはすでに使用されています。再試行してください。",
  "identities.messages.4010009": "リンクされた資格情報が一致しません。",
  "identities.messages.4010010": "入力したアドレスは、現在のアカウントに登録されたアドレスと一致しません。",
  "identities.messages.4040001": "操作の有効期限が切れています。もう一度お試しください。",
  "identities.messages.4040002": "リクエストはすでに成功裏に完了しており、再試行できません。",
  "identities.messages.4040003": "登録コードが無効またはすでに使用されています。再試行してください。",
  "identities.messages.4050001": "操作の有効期限が切れています。もう一度お試しください。",
  "identities.messages.4060001": "リクエストはすでに成功裏に完了しており、再試行できません。",
  "identities.messages.4060002": "復旧フローが失敗状態に達しており、再試行する必要があります。",
  "identities.messages.4060004": "復旧トークンが無効またはすでに使用されています。フローを再試行してください。",
  "identities.messages.4060005": "操作の有効期限が切れています。もう一度お試しください。",
  "identities.messages.4060006": "復旧コードが無効またはすでに使用されています。再試行してください。",
  "identities.messages.4070001": "検証トークンが無効またはすでに使用されています。フローを再試行してください。",
  "identities.messages.4070002": "リクエストはすでに成功裏に完了しており、再試行できません。",
  "identities.messages.4070003": "検証フローが失敗状態に達しており、再試行する必要があります。",
  "identities.messages.4070005": "操作の有効期限が切れています。もう一度お試しください。",
  "identities.messages.4070006": "検証コードが無効またはすでに使用されています。再試行してください。",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "ログアウト",
  "login.registration-button": "登録",
  "login.registration-label": "アカウントをお持ちでないですか？",
  "login.title": "ログイン",
  "login.subtitle": "{parts}でログイン",
  "login.title-aal2": "2段階認証",
  "login.subtitle-aal2": "2段階認証を完了する方法を選択してください",
  "login.code.subtitle": "メールで検証コードが送信されます",
  "login.webauthn.subtitle": "WebAuthNデバイスを準備してください",
  "login.totp.subtitle": "認証アプリで生成されたコードを入力してください",
  "login.lookup_secret.subtitle": "8桁のバックアップ復旧コードの1つを入力してください",
  "login.title-refresh": "再認証",
  "login.subtitle-refresh": "{parts}で身元を確認",
  "login.2fa.go-back": "何か問題がありますか？",
  "login.2fa.go-back.link": "戻る",
  "login.2fa.method.go-back": "別の方法を選択",
  "recovery.title": "アカウントを復旧",
  "recovery.subtitle": "アカウントに関連する識別子を入力して、一時的なアクセスコードを取得してください",
  "registration.login-button": "ログイン",
  "registration.login-label": "アカウントをお持ちですか？",
  "registration.title": "アカウント登録",
  "registration.subtitle": "{parts}で登録",
  "settings.navigation-back-button": "戻る",
  "settings.subtitle": "アカウント設定を更新する",
  "settings.title": "アカウント設定",
  "settings.password.title": "パスワードを変更",
  "settings.password.description": "パスワードを変更",
  "settings.profile.title": "プロフィール設定",
  "settings.profile.description": "プロフィール情報を更新",
  "settings.webauthn.title": "ハードウェアトークンを管理",
  "settings.webauthn.description": "ハードウェアトークンの設定を管理",
  "settings.messages.toast-title.success": "設定が更新されました",
  "settings.messages.toast-title.error": "設定の更新に失敗しました",
  "verification.title": "アカウントを検証",
  "verification.subtitle": "アカウントに関連するメールアドレスを入力して検証してください",
  "two-step.password.title": "パスワード",
  "two-step.password.description": "アカウントに関連するパスワードを入力",
  "two-step.code.title": "メールコード",
  "two-step.code.description": "検証コードがメールで送信されます",
  "two-step.webauthn.title": "セキュリティキー",
  "two-step.webauthn.description": "セキュリティキーを使用して認証",
  "two-step.passkey.title": "パスキー（推奨）",
  "two-step.passkey.description": "デバイスの指紋または顔認識を使用",
  "two-step.passkey.description.error": "パスキーを使用するための必要なライブラリを読み込めませんでした。後で再試行してください。",
  "two-step.totp.title": "認証アプリ（TOTP）を使用",
  "two-step.totp.description": "認証アプリから6桁のワンタイムコードを使用",
  "two-step.lookup_secret.title": "バックアップ復旧コード",
  "two-step.lookup_secret.description": "8桁のバックアップコードの1つを使用して認証",
  "input.placeholder": "{placeholder}を入力",
  "card.header.parts.oidc": "ソーシャルプロバイダー",
  "card.header.parts.password.registration": "あなたの{identifierLabel}とパスワード",
  "card.header.parts.password.login": "あなたの{identifierLabel}とパスワード",
  "card.header.parts.code": "ワンタイムコード",
  "card.header.parts.passkey": "パスキー",
  "card.header.parts.webauthn": "セキュリティキー",
  "card.header.parts.totp": "認証アプリ",
  "card.header.parts.lookup_secret": "バックアップ復旧コード",
  "card.header.parts.identifier-first": "あなたの{identifierLabel}",
  "misc.or": "または",
  "forms.label.forgot-password": "パスワードを忘れた場合？",
  "forms.label.recover-account": "アカウントを復旧",
  "settings.totp.title": "認証アプリ",
  "settings.totp.description": "アカウントにTOTP認証アプリを追加して、アカウントのセキュリティを強化できます。人気のある認証アプリにはLastPassやGoogle Authenticatorがあります。",
  "settings.totp.info.not-linked": "有効にするには、認証アプリでQRコードをスキャンし、コードを入力してください。",
  "settings.totp.info.linked": "現在、認証アプリが接続されています。",
  "settings.lookup_secret.title": "バックアップ復旧コード（2段階認証）",
  "settings.lookup_secret.description": "復旧コードは2段階認証の安全なバックアップであり、2段階認証デバイスを紛失した場合でもアカウントへのアクセスを回復できるようにします。",
  "settings.oidc.title": "接続されたアカウント",
  "settings.oidc.description": "ソーシャルログインプロバイダーをアカウントに接続",
  "settings.oidc.info": "これらのプロバイダーからの接続されたアカウントは、アカウントへのログインに使用できます。",
  "settings.webauthn.info": "ハードウェアトークンは2段階認証に使用されるか、パスキーと併用して1段階認証に使用されます。",
  "settings.passkey.title": "パスキーを管理",
  "settings.passkey.description": "パスキーの設定を管理",
  "settings.passkey.info": "パスキーの設定を管理",
  "card.footer.select-another-method": "別の方法を選択",
  "account-linking.title": "アカウントをリンク",
  "property.password": "パスワード",
  "property.email": "メールアドレス",
  "property.phone": "電話番号",
  "property.username": "ユーザー名",
  "property.identifier": "識別子",
  "property.code": "コード",
  "property.recovery_address": "復旧アドレス",
  "consent.title": "{party}を承認",
  "consent.subtitle": "第三者アプリケーションが、あなたのアカウント{identifier}に関連する情報をアクセスしたいと考えています。",
  "consent.scope.openid.title": "アイデンティティ",
  "consent.scope.openid.description": "アプリケーションがあなたのアイデンティティを検証できるようにします。認証および信頼できるログイン体験に必要です。",
  "consent.scope.offline_access.title": "オフラインアクセス",
  "consent.scope.offline_access.description": "このアプリケーションが、あなたが実際に使用していない場合でも、ログイン状態を維持できるようにします。",
  "consent.scope.profile.title": "プロフィール情報",
  "consent.scope.profile.description": "基本的なプロフィール情報（ユーザー名、名前、姓など）にアクセスできるようにします。",
  "consent.scope.email.title": "メールアドレス",
  "consent.scope.email.description": "メールアドレスとその検証状態を取得できます。",
  "consent.scope.address.title": "住所",
  "consent.scope.address.description": "郵便住所にアクセスできます。",
  "consent.scope.phone.title": "電話番号",
  "consent.scope.phone.description": "電話番号とその検証状態を取得できます。",
  "error.title.what-happened": "何が起きたのですか？",
  "error.title.what-can-i-do": "何ができるでしょうか？",
  "error.instructions": "数分後に再試行するか、サイト管理者に連絡してください。",
  "error.footer.text": "このエラーを報告する際は、以下の情報を含めてください：",
  "error.footer.copy": "コピー",
  "error.action.go-back": "戻る",
  "identities.messages.4000039": "新しいパスワードは古いパスワードと異なる必要があります。",
  "identities.messages.4000040": "有効なメールアドレスを入力してください",
  "identities.messages.4000041": "有効な電話番号を入力してください",
  "captcha.error": "セキュリティ検証に失敗しました。後でもう一度お試しください。問題が解決しない場合は、サポートにお問い合わせください。",
  "identities.messages.5000002": "利用可能な認証方法は存在しません。システム管理者に連絡してください。",
  "identities.messages.4010011": "このアカウントは無効になっています。サポートにお問い合わせください。",
  "identities.messages.1070018": "メールアドレスまたは電話番号",
  "identities.messages.1080004": "お客様にご登録いただいた電話番号宛に、認証コードを含むショートメッセージを送信しました。もしメッセージが届かない場合は、電話番号に誤りがないか確認し、登録されている電話番号をご利用ください。",
  "identities.messages.1080005": "電話番号の認証が完了しました。",
  "identities.messages.5000003": "お客様の組織ではシングルサインオン認証が必要ですが、シングルサインオンプロバイダーが設定されていません。システム管理者にお問い合わせください。",
  "identities.messages.1010024": "ハードウェアキーを使ってログインしてください。",
  "identities.messages.1010025": "コードがアドレスに送信されました。受信していない場合は、もう一度お試しください。",
  "identities.messages.4000042": "デバイス認証の設定がされていません。",
  "identities.messages.4000043": "提供されたウェブ認証ログインの情報が正しくありません。もう一度お試しください。",
  "identities.messages.4000044": "提供されたDeviceAuthn署名は無効です。",
  "identities.messages.4050002": "一度に変更できるのは1つの住所のみです。各住所は個別に更新してください。"
}
